import React from 'react'
import { Row, Col, Card } from 'antd';

import image1 from './assets/images/advanced-option.jpg'
import image2 from './assets/images/clean-design.jpg'
import image3 from './assets/images/easy-customise.jpg'
import image4 from './assets/images/great-support.jpg'
import image5 from './assets/images/modern-design.jpg'
import image6 from './assets/images/unlimited-features.jpg'

const { Meta } = Card;

export default function ViewFeature() {
    return (
        <div id="feature" className='block featureBlock gbGray'>
            <div className="container-fluid">
                <div className="titleHolder">
                    <h2>您將了解以下問題</h2>
                    <span>建立證照地圖，詳細陳列證照與課程學習關聯圖，能有效引導學生學習方向</span>
                </div>
                <Row gutter={[16, 16]}>
                    <Col xs= {{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }}>
                        <Card
                            hoverable
                            cover={<img alt="advanced option" src={image1} />}>
                            <Meta title="基本素養" />
                        </Card>
                    </Col>
                    <Col xs= {{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }}>
                        <Card
                            hoverable
                            cover={<img alt="clean-design" src={image2} />}>
                            <Meta title="核心能力" />
                        </Card>
                    </Col>
                    <Col xs= {{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }}>
                        <Card
                            hoverable
                            cover={<img alt="easy customise" src={image3} />}>
                            <Meta title="升學進修" />
                        </Card>
                    </Col>
                    <Col xs= {{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }}>
                        <Card
                            hoverable
                            cover={<img alt="great support" src={image4} />}>
                            <Meta title="國家考試" />
                        </Card>
                    </Col>
                    <Col xs= {{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }}>
                        <Card
                            hoverable
                            cover={<img alt="modern design" src={image5} />}>
                            <Meta title="專業證照" />
                        </Card>
                    </Col>
                    <Col xs= {{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }}>
                        <Card
                            hoverable
                            cover={<img alt="unlimited features" src={image6} />}>
                            <Meta title="職能就業" />
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    )
}
